/*
  * An Account represents profile information, which is applicable to
    the Owner and Team members of the Account
  * The membership attributes contains the list of all the Users
    which are a part of the account, defined by ROLE
  * There are 3 roles
  ** OWNER - Creater of the Account (aka Plus user)
  ** ADMIN - One who can manage a Team & Subscription
  ** MEMBER - One who can do everything but, manage the Team, Subscriptions and Account information
  * An Account has 1-to-many relationship with Users, defined in the attribute memberships
*/

import Transform from '@app/transformers';

const sideloaded = window['__session__'] || {};
const auth = Transform.auth(sideloaded.user);

export const defaultState = {
  id: null,
  active_subscription: false,
  subscription: {},
  memberships: [],
  lastOrder: null,
  subdomain_name: null,
  wallpapers: [],
  email_background: null,
  use_email_background_for_all_profile_transfers: false,
  transfer_limit: null,
  storage_limit: null,
  payment: {},
};

let accountState = defaultState;

if (auth) {
  accountState = {
    id: auth.account.id,
    active_subscription: auth.account.active_subscription || false,
    subscription: auth.subscription || {},
    memberships: auth.account.memberships || [],
    lastOrder: null, // TODO: move this out this store object
    subdomain_name: auth.account.subdomain_name,
    wallpapers: [],
    email_background: null,
    use_email_background_for_all_profile_transfers:
      auth.account.use_email_background_for_all_profile_transfers || false,
    transfer_limit: auth.account.transfer_limit,
    storage_limit: auth.account.storage_limit,
    use_new_subscription_system: auth.account.use_new_subscription_system,
    payment: {},
  };
}

export default accountState;
